import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  label: string;
  current: number;
  prior?: number;
}

/** YTD cumulative revenue (USD) vs prior year (chart #10). */
export function YtdCumulativeChart({ data }: { data: Row[] }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="label" tick={AXIS} />
        <YAxis tick={AXIS} />
        <Tooltip
          contentStyle={TOOLTIP_STYLE}
          formatter={(v: number) => `$${v.toLocaleString('es-VE')}`}
        />
        <Line
          type="monotone"
          dataKey="current"
          name="Año actual"
          stroke="#3b82f6"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="prior"
          name="Año previo"
          stroke="#64748b"
          strokeWidth={2}
          strokeDasharray="4 4"
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
